<template>
  <div :class="keyboardClass"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default defineComponent({
  name: "SimpleKeyboard",
  components: {},
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String,
    },
    input: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    let keyboard: any = null;

    const onChange = (input: string) => {
      emit("onChange", input);
    };

    const handleShift = () => {
      if (keyboard) {
        const currentLayout = keyboard.options.layoutName;
        const shiftToggle = currentLayout === "default" ? "shift" : "default";
        keyboard.setOptions({
          layoutName: shiftToggle,
        });
      }
    };

    const handleNumbers = () => {
      const currentLayout = keyboard.options.layoutName;
      const numbersToggle = currentLayout !== "numbers" ? "numbers" : "default";

      keyboard.setOptions({
        layoutName: numbersToggle,
      });
    };

    const onKeyPress = (button: any) => {
      emit("onKeyPress", button);
      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") {
        handleShift();
      }
      if (button === "{numbers}" || button === "{abc}") {
        handleNumbers();
      }
    };

    onMounted(() => {
      keyboard = new Keyboard(props.keyboardClass, {
        onChange: onChange,
        onKeyPress: onKeyPress,
        mergeDisplay: true,
        layoutName: "default",
        layout: {
          default: [
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m - {backspace}",
            "{numbers} {space} {ent}",
          ],
          shift: [
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M - {backspace}",
            "{numbers} {space} {ent}",
          ],
          numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"],
        },
        display: {
          "{numbers}": "123",
          "{ent}": "return",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC",
        },
      });
      store.commit("main/setKeyboard", keyboard);
    });

    return {
      store,
    };
  },
});
</script>

<style lang="scss" scoped>
.simple-keyboard {
  position: relative;
  left: 50%;
  max-width: 1200px;
  transform: translateX(-50%);
}
</style>